import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import leave from "../../assets/img/leave.svg"
import trash from "../../assets/img/trash.svg"
import { removeUserAccount } from "../../services/apiProfile";
import { useNavigate } from "react-router-dom";
import Cookies from 'js-cookie';
const DeleteAccount = ({ isLeaveCommunity, handleClose }) => {
    const Group = require("../../assets/img/Featured icon.jpg");
const navigate = useNavigate()
    const removeUser = async () => {
        const user = JSON.parse(localStorage.getItem('userData'));
        const formData = {
            userid: user._id
        }
        let removeAccount = await removeUserAccount(formData);
        if (removeAccount.status) {
            localStorage.clear(); Cookies.remove('authToken'); sessionStorage.removeItem('authToken');
            navigate('/')
        }
    };
    return (

        <div >
            <Modal show={isLeaveCommunity} onHide={handleClose}
                dialogClassName="small-custom-modal modal-dialog-centered">
                <Modal.Header closeButton>
                    <div className="popupheader">
                        <div className="mod-bor-icon" >
                            <img src={trash} className="mod-icon"></img>
                        </div>
                        <div className="header">
                            <div className="signuup">Delete Account</div>
                            {/* <p className="Stronger">{community?.communities?.communityName}</p> */}

                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body>

                    <div>
                        <p className="fov-text">Do you want to delete your account</p>
                    </div>


                </Modal.Body>
                <Modal.Footer className="full-w" >
                    <button type="button" className="cancel-btn" onClick={() => handleClose()}>No</button>
                    <button className="next-btn bg-danger" onClick={() => removeUser()} >Yes</button>
                </Modal.Footer>

            </Modal>
        </div>
    );

};
export default DeleteAccount;
